"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
function createFetchRequest({ method, endpoint, body, headers, customConfig, tokenBuilder, urlPrefix = '', fetchHandler, directOut, }) {
    return __awaiter(this, void 0, void 0, function* () {
        //if the url is a subURL (starts with /) append the base url automatically. Otherwise use it as is
        const isRelative = endpoint === null || endpoint === void 0 ? void 0 : endpoint.startsWith('/');
        const baseURL = isRelative ? urlPrefix : '';
        const fetchConfig = Object.assign({ headers: Object.assign({ 'Content-Type': 'application/json' }, headers), method }, customConfig);
        if (tokenBuilder && isRelative) {
            fetchConfig.headers.Authorization = yield tokenBuilder();
        }
        if (body) {
            fetchConfig.body = JSON.stringify(body);
        }
        try {
            const response = yield fetchHandler(`${baseURL}${endpoint}`, fetchConfig);
            if (response.ok) {
                const parsed = yield response.json();
                return directOut ? parsed : { status: response.status, response: parsed };
            }
            else {
                const contents = yield response.json();
                const errorMessage = {
                    status: response.status,
                    request: Object.assign(Object.assign({}, fetchConfig), { endpoint }),
                    response: contents,
                };
                console.log({ beamError: errorMessage });
                return directOut ? Promise.reject(contents) : Promise.reject(errorMessage);
            }
        }
        catch (err) {
            const errorMessage = {
                request: Object.assign(Object.assign({}, fetchConfig), { endpoint }),
                response: { error: 'Network Error' }
            };
            console.log({ beamError: errorMessage });
            return Promise.reject(errorMessage);
        }
    });
}
exports.default = createFetchRequest;
//# sourceMappingURL=createFetchRequest.js.map